import styled, { createGlobalStyle } from "styled-components";
import { Button, Table } from 'react-bootstrap';
import ButtonWithTooltip from "../../../components/ButtonWithTooltip";

export const Container = styled.div`
  padding: 20px;
`;

export const Title = styled.h3`
  text-align: center;
  margin-bottom: 20px;
`;

export const SubTitle = styled.h4`
  margin-bottom: 20px;
`;

export const TableWrapper = styled.div`
  margin-top: 20px;
`;

export const TableBoot = styled(Table)`
  --bs-table-bg: ${({ theme }) => theme.bg2};
  --bs-table-bg-type: ${({ theme }) => theme.bg3};
  --bs-table-color-state: ${({ theme }) => theme.text};
  border-color: rgb(200, 200, 200);
  width: 89vw;
  height: 89vh;
  font-size: 10px !important;


  /* Estilização para o <thead> */
  th {
    background-color: rgb(225, 225, 225);
    color: rgb(50, 50, 50);
    border-bottom: 1px solid rgb(200, 200, 200);
    box-shadow: none;
    vertical-align: middle;
  }
`;

export const TableCell = styled.th`
  min-width: 15vw;

  @media (max-width: 768px) and (orientation: portrait) {
    min-width: 90vw;
  }
`

export const TableText = styled.span`
  word-wrap: break;
`;

export const CustomizeLI = styled.li`
  text-align: justify;
  font-size: 15px;
`;

export const TextAlign = styled.p`
  text-align: justify;
`;

// se estiver em JS (.js):
export const DadosTD = styled.td`
  background-color: ${({ even, theme }) => even % 2 === 0 ? theme.bgTable : theme.bg2}!important;
  box-shadow: ${({ even, theme }) => even % 2 === 0 ? 'unset' : 'inherit' }!important;
`;

export const SubTableFor = styled.table`
  width: 100%;
  margin: 0;
  border: none;
  background: ${(props) => props.bgcolor};

  --bs-table-bg-type: ${(props) => props.bgcolor};
`;

export const SubTable = styled.table`
  width: 20vw;
  margin: 0;
  border: none;
  background: ${(props) => props.bgcolor};

  --bs-table-bg-type: ${(props) => props.bgcolor};
`;

export const SubTableRow = styled.tr`
  border-bottom: none;
  display: table-row;
`;

export const SubTableForCell = styled.td`
  padding: 8px;
  text-align: center;
  border-right: none;
  width: 50%;
`;

export const SubTableCell = styled.td`
  padding: 8px;
  text-align: center;
  border-right: none;
  width: 10vw;
`;

export const SubTableCellLarger = styled.td`
  padding: 8px;
  text-align: center;
  border-right: none;
  font-size: x-larger;
  display: flex;
  justify-content: space-around;
`;

export const ExpandButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
`;

const BaseButton = styled(ButtonWithTooltip)`
  --bs-btn-bg: transparent;
  --bs-btn-hover-bg: transparent;
  --bs-btn-active-bg: transparent;
  --bs-btn-border-color: transparent;

  font-size: 10px
`;

export const RedFont = styled(BaseButton)`
  --bs-btn-color: red;
  --bs-btn-active-color: red;
  --bs-btn-active-border-color: red;
  --bs-btn-hover-color: red;
  --bs-btn-hover-border-color: red;
`;

export const GreenFont = styled(BaseButton)`
  --bs-btn-color: #00ff00;
  --bs-btn-active-color: #00ff00;
  --bs-btn-active-border-color: #00ff00;
  --bs-btn-hover-color: #00ff00;
  --bs-btn-hover-border-color: #00ff00;  
`;

export const BlackFont = styled(BaseButton)`
  --bs-btn-color: #323232;
  --bs-btn-active-color: #323232;
  --bs-btn-active-border-color: #323232;
  --bs-btn-hover-color: #323232;
  --bs-btn-hover-border-color: #323232;  
`;

export const MarginButton = styled(Button)`
  margin-bottom: 1rem; 
`;

export const NormalFont = styled(BaseButton)`
  --bs-btn-hover-border-color: #fff;
  --bs-btn-active-border-color: #fff; 
`;

export const TdFixed = styled.td`
  position: sticky;
  z-index: ${(props) => props.zIndex || 1};
  left: ${(props) => props.left || '0px'};
  min-width: ${(props) => props.minWidth || '180px'};
`;

export const ThFixed = styled.th`
  position: sticky;
  z-index: ${(props) => props.zIndex || 3};
  left: ${(props) => props.left || '0px'};
  top: 0px;
  min-width: ${(props) => props.minWidth || '180px'};

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
    background-color: #ccc;
  }
`;

export const TheadFixed = styled.thead`
  position: sticky;
  top: 0px;
  z-index: 4;
`;

export const ResponsiveTable =  createGlobalStyle`
  .table-responsive {
    overflow: visible!important;
    font-size: 10px !important;
  }
`;

/* Mapa Comparativo de Cotação: estilos locais, sem afetar os botões do sistema. */
export const MapaScrollArea = styled.div`
  /* Sem scroll independente: ambos os eixos pertencem à página.
     A tabela mantém sua largura natural e provoca overflow no documento. */
  width: max-content;
  min-width: 100%;
  max-width: none;
  height: auto;
  max-height: none;
  overflow: visible;
  position: relative;
  margin: 12px 0;
`;

export const MapaTable = styled(TableBoot)`
  --mapa-produto-largura: clamp(340px, 32vw, 620px);
  --mapa-quantidade-largura: 170px;
  --mapa-fornecedor-largura: clamp(420px, 32vw, 540px);

  width: max-content;
  min-width: 100%;
  height: auto;
  margin-bottom: 0;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;

  col.mapa-col-produto { width: var(--mapa-produto-largura); }
  col.mapa-col-quantidade { width: var(--mapa-quantidade-largura); }
  col.mapa-col-fornecedor { width: var(--mapa-fornecedor-largura); }

  && th.mapa-col-produto,
  && td.mapa-col-produto {
    width: var(--mapa-produto-largura);
    min-width: var(--mapa-produto-largura);
    max-width: var(--mapa-produto-largura);
    left: 0 !important;
    position: sticky;
  }

  && th.mapa-col-quantidade,
  && td.mapa-col-quantidade {
    width: var(--mapa-quantidade-largura);
    min-width: var(--mapa-quantidade-largura);
    max-width: var(--mapa-quantidade-largura);
    left: var(--mapa-produto-largura) !important;
    position: sticky;
  }

  && th.mapa-col-fornecedor,
  && td.mapa-col-fornecedor {
    width: var(--mapa-fornecedor-largura);
    min-width: var(--mapa-fornecedor-largura);
    max-width: var(--mapa-fornecedor-largura);
  }

  && thead th {
    position: sticky;
    top: 0;
    z-index: 5;
    background: #e5e7eb;
    color: #323232;
  }

  && thead .mapa-col-produto,
  && thead .mapa-col-quantidade {
    z-index: 8;
  }

  && tbody .mapa-col-produto,
  && tbody .mapa-col-quantidade,
  && tbody .mapa-col-resumo {
    z-index: 3;
    background: ${({ theme }) => theme?.bg2 || '#fff'};
  }

  && tbody tr:nth-of-type(odd) .mapa-col-produto,
  && tbody tr:nth-of-type(odd) .mapa-col-quantidade,
  && tbody tr:nth-of-type(odd) .mapa-col-resumo {
    background: ${({ theme }) => theme?.bg3 || theme?.bg2 || '#f4f5f7'};
  }

  && .mapa-col-resumo {
    left: 0 !important;
    position: sticky;
  }

  ${SubTable} {
    width: 100%;
  }

  /*
   * Grade do mapa: as bordas precisam permanecer visíveis durante o scroll.
   * No modo border-collapse: separate, bordas normais de células sticky
   * podem ser pintadas atrás de outras células. Desenhamos as divisórias
   * dentro de cada célula para que acompanhem seu posicionamento.
   * As regras abaixo atingem apenas as células da tabela externa do mapa.
   */
  --mapa-cor-borda: #aeb8c8;

  && > thead > tr > th,
  && > tbody > tr > td,
  && > tfoot > tr > td {
    border: 0 !important;
  }

  /* Os cabeçalhos e as colunas fixas já possuem position: sticky.
     Apenas as células comuns precisam de um referencial para a borda. */
  && > tbody > tr > td:not(.mapa-col-produto):not(.mapa-col-quantidade):not(.mapa-col-resumo),
  && > tfoot > tr > td:not(.mapa-col-produto):not(.mapa-col-quantidade):not(.mapa-col-resumo) {
    position: relative;
  }

  && > thead > tr > th::after,
  && > tbody > tr > td::after,
  && > tfoot > tr > td::after {
    content: '';
    position: absolute;
    inset: 0;
    width: auto;
    height: auto;
    display: block;
    box-sizing: border-box;
    background: transparent;
    border: 0;
    border-right: 1px solid var(--mapa-cor-borda);
    border-bottom: 1px solid var(--mapa-cor-borda);
    z-index: 1;
    pointer-events: none;
  }

  /* Fecha a grade nas extremidades sem duplicar a espessura entre células. */
  && > thead > tr > th:first-child::after,
  && > tbody > tr > td:first-child::after,
  && > tfoot > tr > td:first-child::after {
    border-left: 1px solid var(--mapa-cor-borda);
  }

  && > thead > tr:first-child > th::after {
    border-top: 1px solid var(--mapa-cor-borda);
  }

  /* Sobrepõe inclusive hover/active/focus do Bootstrap e do tema, só no mapa. */
  && button,
  && .btn,
  && button:hover,
  && button:focus,
  && button:active,
  && .btn:hover,
  && .btn:focus,
  && .btn:active,
  && button:disabled,
  && .btn:disabled {
    --bs-btn-bg: transparent;
    --bs-btn-hover-bg: transparent;
    --bs-btn-active-bg: transparent;
    --bs-btn-border-color: transparent;
    --bs-btn-hover-border-color: transparent;
    --bs-btn-active-border-color: transparent;
    --bs-btn-box-shadow: none;
    background: transparent !important;
    background-color: transparent !important;
    border-color: transparent !important;
    color: inherit !important;
    box-shadow: none !important;
  }

  && button:focus-visible,
  && .btn:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
`;
